"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));
var _ref = /*#__PURE__*/
_react.default.createElement("path", {
  d: "M1599.04 1523.627L396.373 320.96C546.88 188.053 743.787 106.667 960 106.667c470.507 0 853.333 382.826 853.333 853.333 0 216.107-81.386 413.12-214.293 563.627M106.667 960c0-216.213 81.28-413.12 214.293-563.627L1523.627 1599.04c-150.507 132.907-347.52 214.293-563.627 214.293-470.507 0-853.333-382.826-853.333-853.333M960 0C429.76 0 0 429.76 0 960s429.76 960 960 960c530.133 0 960-429.76 960-960S1490.133 0 960 0",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});
var IconUnpublished = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconUnpublished, _Component);
  function IconUnpublished() {
    (0, _classCallCheck2.default)(this, IconUnpublished);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconUnpublished).apply(this, arguments));
  }
  (0, _createClass2.default)(IconUnpublished, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconUnpublished",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconUnpublished.displayName = "IconUnpublished";
  return IconUnpublished;
}(_react.Component);
exports.default = IconUnpublished;
IconUnpublished.glyphName = 'unpublished';
IconUnpublished.variant = 'Line';
IconUnpublished.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);